import { Col, Row } from "react-bootstrap";
import { Jumbotron } from "sections";

function PromotionNews() {
  return (
    <>
      <style type="text/css">
        {`

            .page{
                margin-top: 80px;
                margin-bottom: 80px;
            }
        
          
            .spacer {
                height: 80px;
            }


            .how-it-works {
                border-radius: 6px;
                border: 1px solid var(--gray-500-body-text, #72788E);
                background: var(--white, #FFF);
                margin-bottom: 16px;
                padding: 10px;
            }

            .content h1{
                color: var(--alrajhi-Brand-1000, #000045);
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: "Ping AR + LT";
                font-size: 18px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;
            }


            .content p{
                color: var(--gray-500-body-text, #72788E);
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: "Ping AR + LT";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
            }


             .content span{
                color: var(--alrajhi-Brand-600, #221AFB);
                font-feature-settings: 'liga' off, 'clig' off;
                font-family: "Ping AR + LT";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-decoration-line: underline;
            }


            .title {
                color: var(--alrajhi-Brand-1000, #000045);
                font-family: "Ping AR + LT";
                font-size: 25px;
                font-style: normal;
                font-weight: 500;
                line-height: 130%; /* 32.5px */
                letter-spacing: -0.575px;
            }







        `}
      </style>

      <div>
        <section className="section jumbotron">
          <Jumbotron
            badgeText="Promotions & Campaigns"
            title={`Saving Made Easy and with alrajhi bank Malaysia’s <span className="jumbotron-subtitle-2">
                5kali3 Cashback Campaign
              </span>`}
            buttonText="Talk to us"
          />
        </section>
      </div>
      <div className="container page">
        <Row>
          <Col md={3} xs={12}>
            <h1 className="title">Latest News</h1>
          </Col>
          <Col md={9} xs={12} className="content">
            <p>
              Al Rajhi Banking & Investment Corporation (Malaysia) Bhd (alrajhi
              bank Malaysia) has launched the 5kali3 Cashback Campaign* designed
              to incentivize smart saving habits and empower Malaysians to
              achieve their financial goals.
              <br></br>
              <br></br>
              Available from both alrajhi bank Malaysia as well as the Bank’s
              digital banking arm Rize, the innovative campaign offers an
              enticing combination of cashback rewards and a competitive profit
              rate (for Rizers), making it easier than ever to build a healthy
              financial future the Shariah-compliant way.
            </p>
          </Col>
        </Row>

        <div className="spacer"></div>

        <Row>
          <Col md={3} xs={12}>
            <h1 className="title">How it works</h1>
          </Col>
          <Col md={9} xs={12} className="content">
            <div className="how-it-works">
              <h1>Flexibilty of Choice</h1>
              <p>
                Open any of three Shariah-compliant accounts: alrajhi bank
                Malaysia's Commodity Murabahah Current Account-i or a Commodity
                Murabahah Savings Account-i, or a Rize Commodity Murabahah
                Savings Account-i.
              </p>
            </div>

            <div className="how-it-works">
              <h1>Cashback for every milestone</h1>
              <p>
                Ensure a minimum deposit RM300 at the end of the first month and
                earn RM5 cashback. Customers must have RM600 and RM900 at the
                end of months two and three to earn another RM5 each time.
                Besides the minimum month-end balances, customers must execute
                at least one of four criteria, which includes transacting with
                their account or debit card). Doing these will earn them a total
                of RM15 in cashback rewards.
              </p>
            </div>

            <div className="how-it-works">
              <h1>Competitive Profit Rate</h1>
              <p>
                With a Rize account, customers get to build their savings even
                faster with a <span>3.3% p.a. profit rate**</span> on their
                account balance.
                <br></br>
                <br></br>
                *Terms and conditions apply
              </p>
            </div>
          </Col>
        </Row>
        <div className="spacer"></div>
        <Row>
          <Col md={3} xs={12}></Col>
          <Col md={9} xs={12}>
            <img
              alt="news-image"
              src="https://picsum.photos/seed/12/700/400"
              width="100%"
            />
          </Col>
        </Row>
        <div className="spacer"></div>
        <Row>
          <Col md={3} xs={12}>
            <h1 className="title">Encouraging Smart Financial Choices</h1>
          </Col>
          <Col md={9} xs={12} className="content">
            <p>
              “At alrajhi bank Malaysia, we understand the importance of saving
              and we're committed to empowering Malaysians to achieve their
              financial goals. The 5kali3 Cashback Campaign is a testament to
              that commitment,” said Syahrul Ishak, Chief Executive Officer of
              alrajhi bank Malaysia.
              <br></br>
              <br></br>
              “By offering cashback incentives and competitive profit rates, we
              hope to encourage a culture of smart saving and help Malaysians
              navigate financial uncertainties. Plus, all alrajhi bank
              Malaysia’s products and services, including those of Rize, are
              Shariah-compliant.
              <br></br>
              <br></br>
              ”The 5kali3 Cashback Campaign runs from 1 July 2024 to 31 December
              2024. Click the following links for more information and the terms
              and conditions of the campaign.
              <br></br>
              <br></br>
              <ul>
                <li>alrajhi bank Malaysia 5kali3 Campaign information</li>
                <li>
                  alrajhi bank Malaysia 5kali3 Campaign terms and conditions
                </li>
                <li>
                  alrajhi bank Malaysia (Rize) 5kali3 Campaign information
                </li>
                <li>
                  alrajhi bank Malaysia (Rize) 5kali3 Campaign terms and
                  conditions
                </li>
              </ul>
              Apart from this campaign, new customers to Rize will be eligible
              for the second phase of the{" "}
              <span>Electrify Your Dreams Campaign</span> in which they stand
              the chance to win a BYD DOLPHIN EV plus monthly cash prizes of up
              to RM200*. In the first phase, Rize customer{" "}
              <span>Bobson Ong drove away with the first of two EV</span>, each
              worth RM125,480, in the campaign. The second phase runs until 30
              November 2024.Deposits in alrajhi bank Malaysia and Rize are
              protected by Perbadanan Insurans Deposit Malaysia (PIDM) up to
              RM250,000 for each depositor.
              <br></br>
              <br></br>
              *alrajhi bank Malaysia 5kali3 Campaign terms and conditions apply
              <br></br>
              ** RIZE DEPOSIT CAMPAIGN 2024 (2) (Extension) terms and conditions
              apply
            </p>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default PromotionNews;
